import type * as Types from '../../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetMediaplanTypeQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
}>;


export type GetMediaplanTypeQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly company?: { readonly __typename?: 'AccountsCompany', readonly mediaplanType?: Types.AccountsCompanyMediaplanType | null } | null, readonly subscription: { readonly __typename?: 'YalperSubscription', readonly planId?: number | null } } | null };


export const GetMediaplanTypeDocument = gql`
    query GetMediaplanType($companyId: ID!) {
  currentUser {
    company(id: $companyId) {
      mediaplanType
    }
    subscription {
      planId
    }
  }
}
    `;

/**
 * __useGetMediaplanTypeQuery__
 *
 * To run a query within a React component, call `useGetMediaplanTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMediaplanTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMediaplanTypeQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetMediaplanTypeQuery(baseOptions: Apollo.QueryHookOptions<GetMediaplanTypeQueryPage, GetMediaplanTypeQueryVariables> & ({ variables: GetMediaplanTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMediaplanTypeQueryPage, GetMediaplanTypeQueryVariables>(GetMediaplanTypeDocument, options);
      }
export function useGetMediaplanTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMediaplanTypeQueryPage, GetMediaplanTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMediaplanTypeQueryPage, GetMediaplanTypeQueryVariables>(GetMediaplanTypeDocument, options);
        }
export function useGetMediaplanTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMediaplanTypeQueryPage, GetMediaplanTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMediaplanTypeQueryPage, GetMediaplanTypeQueryVariables>(GetMediaplanTypeDocument, options);
        }
export type GetMediaplanTypeQueryHookResult = ReturnType<typeof useGetMediaplanTypeQuery>;
export type GetMediaplanTypeLazyQueryHookResult = ReturnType<typeof useGetMediaplanTypeLazyQuery>;
export type GetMediaplanTypeSuspenseQueryHookResult = ReturnType<typeof useGetMediaplanTypeSuspenseQuery>;
export type GetMediaplanTypeQueryResult = Apollo.QueryResult<GetMediaplanTypeQueryPage, GetMediaplanTypeQueryVariables>;